import { useEffect, useState } from "react";
import config from "./config";
import { cachedPost } from "./apiCache";

/**
 * Inline banner ad(s) — rendered in the page flow (e.g. below the banner).
 */
function InlineBanner({ token, groupToken, placement = "community", wrapperClass = "max-w-6xl mx-auto px-4 mt-5 space-y-3" }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    let active = true;
    cachedPost(`${config.COMMUNITY_API_URL}/membership-banners`, {
        community_token: token,
        group_token: groupToken,
        placement,
      }, { ttl: 120000 })
      .then((res) => {
        if (active && res.data?.error === 0) setAds(res.data.inline || []);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [token, groupToken, placement]);

  if (ads.length === 0) return null;

  return (
    <div className={wrapperClass}>
      {ads.map((b) => {
        const img = (
          <img
            src={b.image}
            alt=""
            className="block w-full aspect-[16/9] object-cover transition-transform duration-300 group-hover/ba:scale-[1.02]"
          />
        );
        return (
          <div
            key={b.id}
            className="group/ba overflow-hidden rounded-2xl border border-gray-200 bg-surface shadow-sm ring-1 ring-black/5"
          >
            {b.link ? (
              <a href={b.link} target="_blank" rel="noreferrer" className="block">
                {img}
              </a>
            ) : (
              img
            )}
          </div>
        );
      })}
    </div>
  );
}

export default InlineBanner;
